import { CONSTANTS } from 'common/constants';

export function formatPxToRem(px: number): string {
    return `${px / CONSTANTS.basePX}rem`;
}

export const pr = formatPxToRem;
